var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.customPlansPage)?_c('div',{staticClass:"section-min-width"},[_c('SlicesBlock',{attrs:{"slices":_vm.slices}})],1):_c('Plans',{attrs:{"plans-page":true}})}
var staticRenderFns = []

export { render, staticRenderFns }